import React from "react";

export default React.memo(() => {
  return (
    <svg
      width="100"
      height="21"
      viewBox="0 0 100 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M95.8361 12.7703C95.6996 15.4418 93.3281 17.5236 90.5544 17.1812C88.4339 16.9192 86.7288 15.1922 86.4909 13.0681C86.1741 10.2353 88.3828 7.83599 91.1515 7.83599C93.6609 7.83599 95.7099 9.80607 95.8361 12.2842V12.7703ZM90.5113 4.40753C86.4697 4.72066 83.2763 7.99147 83.0244 12.0002C82.7259 16.7367 86.4792 20.6608 91.1515 20.6608C92.8398 20.6608 95.1244 19.8214 96.1515 18.0484V20.4426H99.3026L99.3091 12.6791C99.3091 7.62285 95.1923 4.04548 90.5113 4.40753Z"
        fill="#144194"
      />
      <path
        d="M68.7269 12.1925C68.7269 10.4903 69.7203 8.53554 71.9254 7.70707C74.4291 6.76766 76.6167 8.01437 77.5378 9.77131L68.7269 12.1925ZM73.2911 4.38591C69.0108 4.50634 65.332 7.83919 65.332 12.6122C65.332 17.0122 68.894 20.691 73.4802 20.691C76.6773 20.691 79.8013 18.764 81.0371 15.6363L77.8999 14.7005C77.3327 15.9837 75.9619 17.1049 74.3794 17.3998C72.1751 17.8107 70.1466 16.4625 69.3502 14.9611L81.5554 11.6348C81.1948 8.5005 78.4451 4.24138 73.2911 4.38591Z"
        fill="#144194"
      />
      <path
        d="M46.4271 7.69559V4.3518C43.3841 4.3518 42.306 5.85107 41.8498 6.681V4.88611H38.379V20.4445H41.9425C41.9395 15.6336 41.9322 15.7131 41.9322 12.8109C41.9322 9.21603 44.0096 7.81749 46.4271 7.69559Z"
        fill="#144194"
      />
      <path
        d="M14.2745 14.193L3.63285 1.66015H0V20.4185H3.75547V7.87329L14.5307 20.4441H17.8606L17.8628 1.66015H14.2745V14.193Z"
        fill="#144194"
      />
      <path
        d="M59.6911 12.7708C59.5546 15.4423 57.1831 17.5241 54.4093 17.1818C52.2889 16.9197 50.5838 15.1927 50.3458 13.0686C50.029 10.2358 52.2378 7.8365 55.0064 7.8365C57.5159 7.8365 59.5648 9.80657 59.6911 12.2847V12.7708ZM63.1487 0H59.7933V6.11752C58.9962 5.07007 56.5071 4.23504 54.3663 4.40803C50.3619 4.73212 47.1312 7.99197 46.8794 12.0007C46.5809 16.7372 50.3341 20.6715 55.0064 20.6715C56.7502 20.6715 59.1779 19.8365 60.0064 18.3635L60.0028 20.4431H63.1487V12.6796C63.1495 12.6292 63.1502 12.5781 63.1502 12.5277C63.1502 12.4766 63.1495 12.4263 63.1487 12.3759V0Z"
        fill="#144194"
      />
      <path
        d="M28.1145 17.2171C25.5254 17.2171 23.4269 15.1185 23.4269 12.5295C23.4269 9.94116 25.5254 7.84263 28.1145 7.84263C30.7035 7.84263 32.802 9.94116 32.802 12.5295C32.802 15.1185 30.7035 17.2171 28.1145 17.2171ZM28.1247 4.3762C23.621 4.3762 19.9707 8.02657 19.9707 12.5295C19.9707 17.0324 23.621 20.6835 28.1247 20.6835C32.6276 20.6835 36.278 17.0324 36.278 12.5295C36.278 8.02657 32.6276 4.3762 28.1247 4.3762Z"
        fill="#144194"
      />
    </svg>
  );
});
